import styled from 'styled-components';

const TopTriangle: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="9" height="4" viewBox="0 0 9 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.78439 0L8.924 3.75H0.644793L4.78439 0Z" />
  </svg>
);

const BottomTriangle: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="9" height="4" viewBox="0 0 9 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.78006 4L0.640457 0.25L8.91966 0.25L4.78006 4Z" />
  </svg>
);

export const SortIndicator: React.FC<{ sortDirection: 'ASC' | 'DESC' | undefined; marginLeft?: number }> = ({
  sortDirection,
  marginLeft = 7,
}) => (
  <S.Container marginLeft={marginLeft}>
    <S.TopTriangle active={sortDirection === 'ASC'} />
    <S.BottomTriangle active={sortDirection === 'DESC'} />
  </S.Container>
);

const S = {
  Container: styled.div<{ marginLeft: number }>`
    display: flex;
    flex-direction: column;
    margin-left: ${({ marginLeft }) => `${marginLeft}px`};
  `,
  TopTriangle: styled(TopTriangle)<{ active: boolean }>`
    margin-bottom: 2px;

    path {
      fill: ${(props) => props.theme.algoanBlue};
      fill-opacity: ${(props) => (props.active ? '1' : '0.2')};
    }
  `,
  BottomTriangle: styled(BottomTriangle)<{ active: boolean }>`
    path {
      fill: ${(props) => props.theme.algoanBlue};
      fill-opacity: ${(props) => (props.active ? '1' : '0.2')};
    }
  `,
};
